import React, { useState } from 'react';
import { Container, CardHeader, Card, CardBody,  Row, Col, Button, Table, Form, FormGroup, Label, Input } from 'reactstrap';
import Papa from 'papaparse';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { api } from "../../../config";
import { fetchComAuth, fetchComAuthJson } from '../../../common/api';

export function ImportExpositoresModal() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState('upload');
  const navigate = useNavigate();
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handlePreview = async () => {
    if (!file) return;
    
    setIsLoading(true);

    try {
      const config = {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          const csvData = results.data;
          const fields = results.meta.fields || [];
          
          const previewData = {
            totalRecords: csvData.length,
            fieldMapping: fields.reduce((acc, field) => {
              acc[field] = field;
              return acc;
            }, {}),
            preview: csvData.slice(0, 10)
          };

          setPreview(previewData);
          setStep('preview');
          setIsLoading(false);
        },
        error: (error) => {
          alert('Erro ao processar CSV: ' + error.message);
          setIsLoading(false);
        }
      };

      Papa.parse(file, config);
      
    } catch (error) {
      alert('Erro ao processar arquivo: ' + error.message);
      setIsLoading(false);
    }
  };

    const salvar = async () => {
  
    };
  
    const handleConfirmImport = async () => {
      if (!file) return;
    
      setIsLoading(true);
    
      const formData = new FormData();
      formData.append('csv_file', file);
    
      try {
        const response = await fetchComAuthJson(`${api.API_URL}/expositor/importar`, {
          method: 'POST',
          body: formData,
        });
    
        const result = await response.json();
    
        if (response.ok) {
          toast.success(`Importação concluída com sucesso!`);
          setStep('done');
        } else {
          toast.error(`Erro ao importar: ${result.message}`);
        }
      } catch (error) {
        toast.error(`Erro na requisição: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    

  return (
      <React.Fragment>
        <ToastContainer closeButton={false} />
          <Row>
            <Col md="12">
              <Card>
             
                <CardBody>
                  {step === 'upload' && (
                    <Form>
                      <FormGroup>
                        <Label for="csvFile">Selecione o arquivo CSV</Label>
                        <Input 
                          type="file" 
                          id="csvFile" 
                          accept=".csv" 
                          onChange={handleFileChange} 
                        />
                      </FormGroup>
                      
                      <Button 
                        color="primary" 
                        onClick={handlePreview} 
                        disabled={!file || isLoading}
                      >
                        {isLoading ? 'Processando...' : 'Pré-visualizar'}
                      </Button>
                    </Form>
                  )}

                  {step === 'preview' && preview && (
                    <div>
                      <div className="mb-4">
                        <p className="lead">Confirmação de Importação</p>
                        <p>Total de registros: <strong>{preview.totalRecords}</strong></p>
                        
                      </div>

                      <div className="table-responsive mb-4">
                        <Table striped bordered hover>
                          <thead>
                            <tr>
                              {Object.keys(preview.fieldMapping).map(key => (
                                <th key={key}>{preview.fieldMapping[key]}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {preview.preview.map((row, i) => (
                              <tr key={i}>
                                {Object.keys(preview.fieldMapping).map(key => (
                                  <td key={key}>{row[key] || '-'}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>

                      <div className="d-flex justify-content-between">
                        <Button color="secondary" onClick={() => setStep('upload')}>
                          Voltar
                        </Button>
                        <Button 
                          color="success" 
                          onClick={handleConfirmImport} 
                          disabled={isLoading}
                        >
                          {isLoading ? 'Importando...' : 'Confirmar Importação'}
                        </Button>
                      </div>
                    </div>
                  )}

                  {step === 'done' && (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="fas fa-check-circle fa-5x text-success mb-3"></i>
                        <h3>Importação Concluída!</h3>
                        <p>Os expositores foram importados com sucesso.</p>
                      </div>
                      <Button color="primary" onClick={() => {
                        setStep('upload');
                        setFile(null);
                        setPreview(null);
                      }}>
                        Importar outro arquivo
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          
    </React.Fragment>
  );
}

export default ImportExpositoresModal;